import { render, staticRenderFns } from "./WrapperNodeProperties.vue?vue&type=template&id=57b0e8eb&scoped=true"
import script from "./WrapperNodeProperties.vue?vue&type=script&lang=js"
export * from "./WrapperNodeProperties.vue?vue&type=script&lang=js"
import style0 from "./WrapperNodeProperties.vue?vue&type=style&index=0&id=57b0e8eb&prod&scoped=true&lang=scss"
import style1 from "./WrapperNodeProperties.vue?vue&type=style&index=1&id=57b0e8eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b0e8eb",
  null
  
)

export default component.exports